import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams, useLocation } from 'react-router-dom';
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../context/AlertContext";
import CcSection from "./CcSection";
import constants from "../../../constants";
import Loading from "../../Notification-Loading/Loading/Loading";
import { getDataFromStorage, MANAGEMENTROLES } from "../../../util";
import CcSecQnsUtils from "./CcSecQnsUtils";
import ccSecQnsUtils from "./ccSecQnsUtils.json";
import Search from "../../CommonComponents/Search";
// import IconButton from "../../CommonComponents/IconButton";
import { useDebouncedValue } from "../../../Hooks/useDebounceValue";
import { DropdownMenu } from "../../CommonComponents/InputDropdown";

const sectionRank = {
  22: 1,
  23: 2,
  1: 3,
  2: 4,
  3: 5,
  4: 6,
  5: 7,
  8: 8,
  7: 9,
  6: 10,
  9: 11,
  13: 12,
  10: 13,
  11: 14,
  12: 15,
  14: 16,
  15: 17,
  16: 18,
  17: 19,
  19: 20,
  20: 21,
  18: 22,
  21: 23,
  24: 24,
}

const CcHome = () => {
  const { idHash, username } = useParams();
  const { pathname } = useLocation();
  const { setShowNotify, setIsLoaded, isLoaded } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const [ccSections, setCcSections] = useState([]);
  const [qnFilterCount, setQnFilterCount] = useState({});
  const [activeCard, setActiveCard] = useState(null);
  // const [showFilter, setShowFilter] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useDebouncedValue(searchValue, 2000);
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef(null);
  const dropdownId = "cc-sort-dropdown";
  useEffect(() => {
    const fetchSections = async () => {
      setIsLoaded(true);
      try {
        let response = await axios.get(
          (pathname.includes("/u/")) ?
            `node/public/u/${idHash}/${username}/cc/section?name=${searchValue}`
            : `node/learner/cc/section?name=${searchValue}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          setCcSections(response.data.data ?? []);
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: response.data.msg || "Something went wrong. Please try again later or contact gradious team.",
          });
        }
        if (response?.data?.data?.length >= 1) {
          setQnFilterCount({
            categoryCount: response.data.resultObj.solvedCount,
            totalCount: response.data.resultObj.totalCount ?? 0,
            firstCount: response.data.resultObj.firstCount ?? 0,
            attemptCount: response.data.resultObj.attemptCount ?? 0,
            solvedCount: {
              totalCount: response.data.resultObj.solvedCount.reduce(
                (accumulator, currentValue) =>
                  accumulator + currentValue.count ?? 0,
                0
              ),
              categoryCount: response.data.resultObj.solvedCount,
            },
          });
        }
      } catch (error) {
        console.log(error);
        if (error.message.includes("403")) {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
            isUnAuth: true,
          });
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: error.message,
          });
        }
      } finally {
        setIsLoaded(false);
      }
    };
    fetchSections();
  }, [axios, setIsLoaded, setShowNotify, debouncedSearchValue]);

  const onClickFilter = (value) => {
    // setQnsFilterValue((prev) =>
    //   Object.keys(prev).reduce((acc, key) => {
    //     acc[key] = key === value;
    //     return acc;
    //   }, {})
    // );
    console.log("button is not clickable here");
  };

  const sortOptions = [
    {
      label: "Ascending",
      value: "asc",
    },
    {
      label: "Descending",
      value: "desc",
    },
  ];

  return (
    <div className="ccContainer">
      <div className="ccSection">
        <div className="ccSectionHeadTitle">
          <div className="ccTitle">
            <span>Coding Challenges</span>
            <div className="ccTitleActions" ref={anchorRef}>
              <div
                onClick={() => setIsOpen((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                <svg
                  width="20"
                  height="20"
                  fill="none"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke="#667085"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                  />
                </svg>
              </div>
              {isOpen && (
                <DropdownMenu
                  placement="bottom-start"
                  className="ccHomeSortDropdown"
                  style={{
                    width:
                      anchorRef.current?.getBoundingClientRect().width || 220,
                  }}
                  open={isOpen}
                  anchorRef={anchorRef}
                  dropdownId={dropdownId}
                  options={[
                    { label: "Basic to Advance", value: "asc" },
                    { label: "Advance to Basic", value: "desc" },
                  ]}
                  value={sortOrder}
                  multiple={false}
                  onSelectOption={(val) => {
                    setSortOrder(val);
                    setIsOpen(false);
                  }}
                  onClose={() => setIsOpen(false)}
                />
              )}
              <Search
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
              />
            </div>
          </div>
          <div className="ccSecQnsUtilsContainer">
            {ccSecQnsUtils.map((item) => (
              <CcSecQnsUtils
                item={item}
                key={item.key}
                count={qnFilterCount[item.key]}
                onClick={onClickFilter}
                activeCard={activeCard}
                // setActiveCard={setActiveCard}
                notClickable={true}
                className={"not-clickable"}
              />
            ))}
          </div>
        </div>
        {/* <div className="ccSectionsContainer">
          {ccSections.map((item) => (
            <CcSection data={item} key={item.id} />
          ))}
        </div> */}

        <div className="ccSectionsContainer">
          {[...ccSections]
            .sort((a, b) => {
              const aRank = sectionRank[a.id] ?? Infinity;
              const bRank = sectionRank[b.id] ?? Infinity;
              return sortOrder === "asc" ? aRank - bRank : bRank - aRank;
            })
            .map((item) => (
              <CcSection data={item} key={item.id} />
            ))
          }
        </div>

      </div>
      {isLoaded && MANAGEMENTROLES.includes(getDataFromStorage("role")) && (
        <Loading />
      )}
    </div>
  );
};

const SortOrderFilter = ({ sortOrder, setSortOrder }) => {
  const renderTickIcon = (isSelected) =>
    isSelected && (
      <svg
        className="inputDropdownMenuItemIcon tickIcon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6668 5L7.50016 14.1667L3.3335 10"
          stroke="#16A34A"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

  return (
    <ul className="difficultyFilterContainer">
      <li
        className={`difficultyItem ${sortOrder === "asc" ? "selected" : ""}`}
        onClick={() => setSortOrder("asc")}
      >
        Ascending
        {renderTickIcon(sortOrder === "asc")}
      </li>
      <li
        className={`difficultyItem ${sortOrder === "desc" ? "selected" : ""}`}
        onClick={() => setSortOrder("desc")}
      >
        Descending
        {renderTickIcon(sortOrder === "desc")}
      </li>
    </ul>
  );
};

export default CcHome;